import React, { useState } from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Box,
  Typography,
  Container,
  CircularProgress,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import PublicLayout from "layouts/publicLayout";
import Copyright from "components/copyright";
import axios from "axios";
import { toast } from "react-toastify";
import { blue } from "@mui/material/colors";
import ErrorAlert from "helper/errorAlert";
import { useApiClient } from "context/ApiClientContext";

const defaultTheme = createTheme();

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const apiClient = useApiClient();
  
  const handleAccount = (property, event) => {
    const dataCopy = { ...data };
    dataCopy[property] = event.target.value;
    setData(dataCopy);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const encodeEmail = encodeURIComponent(`${data.identifier}`);

      const response = await axios.get(
        `${apiClient}/user/forgetpasswd?email=${encodeEmail}`,
        {
          Authorization:`Bearer ${localStorage.getItem('token')}`,
        }
      );

      toast.success("Please check your email for new temporary password.", {
        position: "top-right",
      });

      navigate("/signin");
    } catch (error) {
      ErrorAlert(error, navigate)
      console.error("Authentication failed!", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
            <LockOutlinedIcon />
          </Avatar> */}
          <Typography>
            Lost your password? Please enter your email address. You will
            receive a link to create a new password via email.
          </Typography>

          <TextField
            onChange={(event) => handleAccount("identifier", event)}
            margin="normal"
            required
            fullWidth
            variant="standard"
            id="email"
            label="Email"
            name="email"
            autoFocus
          />
          <Box display="flex" justifyContent="start" fullWidth>
            <Box sx={{ m: 1, position: "relative" }}>
              <Button
                variant="contained"
                disabled={loading || !data.identifier}
                onClick={handleSubmit}
              >
                Request New Password
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: blue[800],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </Box>
          <Grid container sx={{ mt: 4 }}>
            <Grid item xs>
              Remember your password?{" "}
              <Link href="/signin" variant="body2">
                Click Here
              </Link>
            </Grid>
          </Grid>
          {/* </Box> */}
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
      {/* </ThemeProvider> */}
    </PublicLayout>
  );
}
